import dayjs from 'dayjs'
import { appVersion } from 'src/consumer/services'
import {
  getAppInstallationId,
  getAumhumScreenId,
  getGeoLocation,
  getIpAddressFromLocalStorage,
  getSelectedCameraInLocalStorage,
  getSelectedMicrophoneInLocalStorage,
  getSelectedSpeakerInLocalStorage,
} from 'src/consumer/services/localstorageServices'

export default function useAppUpdateAction() {
  function prepareAppUpdateActionPayload() {
    let geoLocation = getGeoLocation()
    if (geoLocation !== 'undefined' && !!geoLocation) {
    } else {
      geoLocation = null
    }

    let AUMHUM_SCREEN_ID = getAumhumScreenId()
    let ROLE_CA_CONFIG = localStorage.getItem('ROLE_CA_CONFIG')
    let screenDeviceId = null
    if (ROLE_CA_CONFIG) {
      let roleCaConfig = JSON.parse(ROLE_CA_CONFIG)
      screenDeviceId = roleCaConfig.SCREEN_DEVICE_CONFIG_ID
    }
    // Flow is implied by the portal now (not a stored field); derive it from
    // the current path for the heartbeat payload.
    const path = typeof window !== 'undefined' ? window.location.pathname : ''
    const flowId = path.startsWith('/display')
      ? 'appointment-screen'
      : path.startsWith('/kiosk')
        ? 'remote-doctor'
        : 'reception-tablet'

    let selectedCamera = getSelectedCameraInLocalStorage()
    let selectedMicrophone = getSelectedMicrophoneInLocalStorage()
    let selectedSpeaker = getSelectedSpeakerInLocalStorage()

    return {
      screenId: AUMHUM_SCREEN_ID,
      flowId: flowId,
      clientIpAddress: getIpAddressFromLocalStorage(),
      clientUserAgent: navigator.userAgent,
      screenDeviceConfigId: screenDeviceId,
      appVersion: appVersion,
      location: geoLocation,
      appInstallationId: getAppInstallationId(),
      timestamp: dayjs().utc().format('YYYY-MM-DD HH:mm:ss'),
      status: 'OK',
      selectedCamera: selectedCamera,
      selectedMicrophone: selectedMicrophone,
      selectedSpeaker: selectedSpeaker,
    }
  }

  return { prepareAppUpdateActionPayload }
}

// public class AumhumScreenHeartBeat {
//     private String appVersion;
//     private String clientIpAddress; //
//     private String clientUserAgent; //
//     private String status = "OK"; // OK, OFFLINE, etc. //
//     @JsonFormat(shape = JsonFormat.Shape.STRING, pattern = "yyyy-MM-dd HH:mm:ss", timezone = "UTC")
//     @DateTimeFormat(iso = DateTimeFormat.ISO.DATE_TIME)
//     private Location location;
//     private String locationTag;
//     private String loggedInUserId;
//     private Instant timestamp; // From client//
//     private String appInstallationId;

//     @JsonFormat(shape = JsonFormat.Shape.STRING, pattern = "yyyy-MM-dd HH:mm:ss", timezone = "UTC")
//     @DateTimeFormat(iso = DateTimeFormat.ISO.DATE_TIME)
//     private Instant receivedAt; // Server time
//     private String serverVersion;
//     private String ipAddress;

//     @Id
//     private String id;
//     private String screenId;
//     private String osType;
//     private String osVersion;
//     private Long uptime;
//     private Double batteryLevel; // future
//     private String networkStatus;
//     private Double diskUsage; // future
//     private String errorLogs; // future

// }
